import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory({ basename: '' });
export var reactPlugin = new ReactPlugin();
export var appInsights = new ApplicationInsights({
    config: {
        connectionString: `InstrumentationKey=${process.env.REACT_APP_AZURE_INSTRUMENTATION_KEY};IngestionEndpoint=${process.env.REACT_APP_AZURE_INVESTIGATION_ENDPOINT};LiveEndpoint=${process.env.REACT_APP_AZURE_LIVE_ENDPOINT}`,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView();